import { Box, Button, Stack } from '@mui/material';

import { useExitProductDemo } from '~modules/product-demo/hooks/use-exit-product-demo';
import { useProductDemoMode } from '~modules/product-demo/hooks/use-product-demo-mode';
import { PRODUCT_DEMO_BANNER_ID } from '~modules/product-demo/product-demo-anchors';

import { AppIcon } from '~components/shared/app-icon/app-icon';
import { AppTypography } from '~components/ui/typography/app-typography';

import { ReactComponent as IconArrowRightLg } from '~assets/icons/icon-arrow-right-lg.svg';

export const ProductDemoBanner = () => {
  const { isDemoMode } = useProductDemoMode();
  const exitProductDemo = useExitProductDemo();

  if (!isDemoMode) return null;

  return (
    <Box
      id={PRODUCT_DEMO_BANNER_ID}
      sx={{
        px: { xs: 2, sm: 3 },
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'primaryTokens.50',
        backgroundColor: 'primaryTokens.10',
        mb: {
          xs: 0,
          md: 2,
        },
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack gap={{ xs: 1, sm: 0.75 }} mb={0.5}>
          <AppTypography size="body-md" weight="semibold" color="fog.15">
            Демо-режим
          </AppTypography>
          <AppTypography size="body-sm" color="fog.35">
            Це приклад кабінету з тестовими даними. Тут можна подивитися, як
            працюють оренда, платежі та нагадування.
          </AppTypography>
        </Stack>

        <Button
          size="small"
          variant="contained"
          onClick={exitProductDemo}
          endIcon={<AppIcon component={IconArrowRightLg} size={20} />}
          sx={{ minWidth: '220px' }}
        >
          Налаштувати кабінет
        </Button>
      </Stack>
    </Box>
  );
};
